import { Grid } from '@mui/material'
import {
  AlertPosition,
  DateRange,
  LocalizedCombobox,
  PageLayoutWithTitleAndInfo,
  RedirectButton,
  SubmitButtonWithAlert,
  UpdateForm
} from '../../../components'
import { AlertProvider } from '../../../contexts'
import { SAVE_PAYMENT_EXEMPTION } from '../../../graphql'
import { ROUTE_MEMBERSHIP_FEES } from '../../../routes'
import { isRequired } from '../../../utils'
import { usePaymentExemptionFormData } from './hooks'

export const AddPaymentExemption = () => {
  const { createVariables, initialValues, validationSchema } =
    usePaymentExemptionFormData()

  return (
    <PageLayoutWithTitleAndInfo
      infoBoxProps={{
        translationId: 'pages.paymentExemptionsPage.infoBoxText'
      }}
      titleTranslationTopId="pages.paymentExemptionsPage.title"
    >
      <AlertProvider>
        <UpdateForm
          query={SAVE_PAYMENT_EXEMPTION}
          createVariablesFn={createVariables}
          formikProps={{
            initialValues,
            validationSchema
          }}
          resetFormOnSubmit
          submitCheckerProps={{
            successMessageId: 'pages.paymentExemptionsPage.save.success',
            errorMessageId: 'pages.paymentExemptionsPage.save.error'
          }}
        >
          <Grid
            container
            columnSpacing={4}
            sx={{ mb: 2, mt: 1, minHeight: '70px' }}
          >
            <Grid item md={5} xs={12}>
              <DateRange
                endDateProps={{
                  name: 'loppupvm',
                  required: isRequired('loppupvm', validationSchema),
                  labelTranslationId: 'pages.paymentExemptionsPage.endDate.text'
                }}
                startDateProps={{
                  name: 'alkupvm',
                  required: isRequired('alkupvm', validationSchema),
                  labelTranslationId:
                    'pages.paymentExemptionsPage.startDate.text'
                }}
                spacing={4}
              />
            </Grid>
            <LocalizedCombobox
              name="syykoodi"
              localizedOptionsKey="exemptionReasonOptions"
              labelTranslationId="pages.paymentExemptionsPage.reason.text"
              required={isRequired('syykoodi', validationSchema)}
            />
          </Grid>
          <Grid container alignItems="center" spacing={{ md: 4, xs: 2 }}>
            <Grid item md={true} xs={12} />
            <Grid item md="auto" xs={12}>
              <RedirectButton
                redirectPath={ROUTE_MEMBERSHIP_FEES}
                translationId="common.cancel"
              />
            </Grid>
            <Grid item md="auto" xs={12}>
              <SubmitButtonWithAlert
                alertProps={{ alertPosition: AlertPosition.RIGHT }}
                buttonProps={{
                  translationId: 'pages.paymentExemptionsPage.save.buttonText'
                }}
              />
            </Grid>
          </Grid>
        </UpdateForm>
      </AlertProvider>
    </PageLayoutWithTitleAndInfo>
  )
}
